<template>
    <!-- Conteneur principal pleine largeur -->
    <div class="ppv2-w-full">
        <div class="ppv2-min-h-screen">
            <div class="ppv2-rounded-lg ppv2-shadow-sm ppv2-p-4 md:ppv2-p-6">
                <!-- Message d'erreur -->
                <div v-if="error" class="ppv2-bg-red-50 ppv2-border ppv2-border-red-200 ppv2-rounded-lg ppv2-p-4 ppv2-mb-4">
                    <div class="ppv2-flex ppv2-items-center">
                        <svg class="ppv2-h-5 ppv2-w-5 ppv2-text-red-600 ppv2-mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span class="ppv2-text-red-800">{{ error }}</span>
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center">
                    <Header :title="$t('invoices.title')" />
                    <!--<button
                        @click="showAddDropdown = !showAddDropdown"
                        class="ppv2-min-h-[40px] ppv2-flex ppv2-items-center !ppv2-text-white hover:ppv2-text-white ppv2-rounded-xl ppv2-bg-[#7D2DBD] ppv2-text-white hover:ppv2-bg-[#6b26a3] ppv2-transition-all ppv2-shadow-lg"
                    >
                        <div class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-px-6 ppv2-h-full">
                            <Plus :size="20" />
                            <span class="poppinsMedium">{{ $t('invoices.create_invoice') }}</span>
                        </div>
                        <div class="ppv2-w-[3px] ppv2-h-[40px] ppv2-bg-white"></div>
                        <div class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-px-4 ppv2-h-full">
                            <ChevronDown
                                :size="20"
                                :class="{ 'ppv2-rotate-180': showAddDropdown }"
                                class="ppv2-transition-transform ppv2-duration-200"
                            />
                        </div>
                    </button>
                    <div
                        v-if="showAddDropdown"
                        class="menuDropdown ppv2-absolute ppv2-right-0 ppv2-top-full ppv2-overflow-hidden ppv2-shadow-lg ppv2-z-50"
                    >
                        <button
                            @click="openAddOption1"
                            class="dropdownItem ppv2-w-full ppv2-text-left ppv2-px-4 ppv2-py-2 ppv2-transition-colors ppv2-flex ppv2-items-center ppv2-gap-3"
                        >
                            <Plus :size="16" />
                            <span class="poppinsLight ppv2-text-gray-700" :style="{ fontSize: normalizeFontSize(14) }">
                                {{ $t('invoices.option_1') }}
                            </span>
                        </button>
                        <button
                            @click="openAddOption2"
                            class="dropdownItem ppv2-w-full ppv2-text-left ppv2-px-4 ppv2-py-2 ppv2-transition-colors ppv2-flex ppv2-items-center ppv2-gap-3"
                        >
                            <Plus :size="16" />
                            <span class="poppinsLight ppv2-text-gray-700" :style="{ fontSize: normalizeFontSize(14) }">
                                {{ $t('invoices.option_2') }}
                            </span>
                        </button>
                    </div>-->
                </div>

                <!-- Stats Cards -->
                <div
                    class="ppv2-max-w-1/2 ppv2-mb-6 ppv2-grid ppv2-grid-cols-1 lg:ppv2-grid-cols-3 md:ppv2-grid-cols-2"
                    :style="{ gap: normalizeSize(38, true) }"
                >
                    <!-- Montant Facturé -->
                    <div class="cardCAFact ppv2-flex align-items-center ppv2-gap-1">
                        <div class="ppv2-px-4 ppv2-py-6 ppv2-text-white ppv2-w-[49%]">
                            <div :style="{ fontSize: normalizeFontSize(20) }">{{ $t('invoices.stats.ca_factured') }}</div>
                            <div class="poppinsSemiBold" :style="{ fontSize: normalizeFontSize(25) }">
                                {{ formatCurrency(stats.validated_invoices?.invoiced_amount || 0) }} {{ $t('invoices.stats.ht') }}
                            </div>
                        </div>
                        <div class="ppv2-w-[1px] ppv2-h-[90%] ppv2-bg-white" />

                        <!-- Montant Encaissé -->
                        <div class="ppv2-px-4 ppv2-py-6 ppv2-text-white ppv2-w-[49%]">
                            <div :style="{ fontSize: normalizeFontSize(20) }">{{ $t('invoices.stats.ca_paid') }}</div>
                            <div class="poppinsSemiBold" :style="{ fontSize: normalizeFontSize(25) }">
                                {{ formatCurrency(stats.validated_invoices?.collected_amount || 0) }}
                                {{ $t('invoices.stats.ttc') }}
                            </div>
                        </div>
                    </div>

                    <!-- Factures en retard -->
                    <div
                        class="ppv2-rounded-lg ppv2-bg-white ppv2-px-4 ppv2-py-6 ppv2-text-[#000000] ppv2-shadow-lg ppv2-w-[55%]"
                    >
                        <div class="ppv2-flex ppv2-items-center ppv2-gap-2">
                            <div class="ppv2-text-[#000000] ppv2-text-opacity-50" :style="{ fontSize: normalizeFontSize(20) }">
                                {{ $t('invoices.stats.overdue_invoices') }}
                            </div>
                            <div
                                class="ppv2-bg-[#DBA800] ppv2-text-white ppv2-w-6 ppv2-h-6 ppv2-flex ppv2-items-center ppv2-justify-center ppv2-rounded-full ppv2-text-xs poppinsMedium"
                            >
                                {{ stats.overdue_invoices?.count || 0 }}
                            </div>
                        </div>
                        <div class="poppinsSemiBold" :style="{ fontSize: normalizeFontSize(25) }">
                            {{ formatCurrency(stats.overdue_invoices?.amount || 0) }} {{ $t('invoices.stats.ht') }}
                        </div>
                    </div>
                </div>

                <!-- Filters Row -->
                <div class="ppv2-flex ppv2-flex-col md:ppv2-flex-row ppv2-justify-start md:ppv2-justify-between">
                    <div class="ppv2-mb-6 ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-gap-3">
                        <!-- Search and Export -->
                        <!-- Search Input -->
                        <div class="ppv2-relative">
                            <Search
                                v-model="searchQuery"
                                :emitGlobal="false"
                                :keep-open-on-search="true"
                                @search-updated="handleSearchUpdate"
                            />
                        </div>

                        <!-- Date Range Picker (Composant dynamique) -->
                        <invoice-date-filter
                            :start-date.sync="dateRange.start"
                            :end-date.sync="dateRange.end"
                            @change="handleDateChange"
                        >
                        </invoice-date-filter>

                        <!-- More Filters
                        <filter-dropdown
                            :label="$t('invoices.filter_type')"
                            :options="availableFilters.orderStatuses || []"
                            v-model="filters.status_id"
                            :multiple="true"
                            @change="handleFilterChange"
                        >
                            <template #icon>
                                <FileText :size="17" />
                            </template>
                        </filter-dropdown>

                         Invoice Type Filter -->
                        <filter-dropdown
                            :label="$t('invoices.columns.type')"
                            :options="availableFilters.types || []"
                            v-model="filters.type_id"
                            :multiple="true"
                            @change="handleFilterChange"
                        >
                            <template #icon>
                                <FileText :size="17" />
                            </template>
                        </filter-dropdown>

                        <!-- Filtres -->
                        <button
                            @click="showAdvancedFilters = true"
                            class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20 ppv2-rounded-lg ppv2-px-3 ppv2-py-2 ppv2-text-sm ppv2-text-gray-700 hover:ppv2-bg-gray-50 ppv2-transition-colors"
                        >
                            <LayoutGrid :size="18" />
                            <span class="ppv2-hidden md:ppv2-inline">{{ $t('invoices.filter_advanced') }}</span>
                        </button>
                        <div class="md:ppv2-hidden ppv2-block">
                            <ExportSelect
                                v-if="canExportInvoices"
                                :label="$t('invoices.export')"
                                :options="exportOptions"
                                :loading="isExporting"
                                @export-selected="handleExport"
                                :hide-label-on-mobile="true"
                            />
                        </div>

                        <!-- Modifier les colonnes (mobile) -->
                        <div class="ppv2-relative md:ppv2-hidden" ref="columnsDropdownMobile">
                            <button
                                @click="showColumns = !showColumns"
                                class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20 ppv2-rounded-lg ppv2-px-3 ppv2-py-2 ppv2-text-sm ppv2-text-gray-700 hover:ppv2-bg-gray-50 ppv2-transition-colors"
                            >
                                <FilePen :size="18" />
                                <span>{{ $t('invoices.columns_short') }}</span>
                                <ChevronDown :size="16" />
                            </button>
                            <!-- Dropdown -->
                            <div
                                v-if="showColumns"
                                class="menuDropdown ppv2-absolute ppv2-top-full ppv2-left-0 ppv2-mt-2 ppv2-rounded-md ppv2-overflow-hidden ppv2-z-50"
                            >
                                <div class="ppv2-max-h-[300px] ppv2-overflow-y-auto">
                                    <label
                                        v-for="(column, index) in allColumns"
                                        :key="index"
                                        class="dropdownItem ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-1 ppv2-cursor-pointer ppv2-transition-colors"
                                    >
                                        <BaseCheckbox
                                            :value="selectedColumnKeys.includes(column.key)"
                                            @input="toggleColumn(column.key)"
                                            size="sm"
                                            :hasBorderChecked="true"
                                        />
                                        <span class="poppinsLight" :style="{ fontSize: normalizeFontSize(14) }">{{
                                            column.label
                                        }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ppv2-mb-6 ppv2-hidden md:ppv2-block">
                        <ExportSelect
                            v-if="canExportInvoices"
                            :label="$t('invoices.export')"
                            :options="exportOptions"
                            :loading="isExporting"
                            @export-selected="handleExport"
                        />
                    </div>
                </div>

                <!-- Active Filters Badges -->
                <div v-if="activeFiltersCount > 0" class="ppv2-mb-6 ppv2-flex ppv2-flex-wrap ppv2-gap-2 ppv2-items-center">
                    <div
                        v-for="(filter, key) in activeFiltersPills"
                        :key="key"
                        class="ppv2-inline-flex ppv2-items-center ppv2-gap-2 ppv2-bg-gray-100 ppv2-text-gray-700 ppv2-px-3 ppv2-py-1.5 ppv2-rounded-lg ppv2-text-xs poppinsMedium ppv2-border ppv2-border-gray-200"
                    >
                        <span class="ppv2-opacity-70">{{ filter.label }}:</span>
                        <span class="poppinsSemiBold">{{ filter.value }}</span>
                        <button
                            @click="removeFilter(key)"
                            class="ppv2-ml-1 ppv2-text-gray-400 hover:ppv2-text-red-500 ppv2-transition-colors"
                        >
                            <X :size="14" />
                        </button>
                    </div>
                    <button
                        @click="clearAllFilters"
                        class="ppv2-text-xs ppv2-text-red-500 hover:ppv2-text-red-700 poppinsMedium ppv2-ml-2 hover:ppv2-underline ppv2-transition-all"
                    >
                        {{ $t('invoices.remove_all_filters') }}
                    </button>
                </div>

                <!-- Type Filter Pills -->
                <div class="ppv2-mb-6 ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-gap-3">
                    <button
                        v-for="filter in typeFilters"
                        :key="filter.id"
                        :class="[
                            'ppv2-rounded-full md:ppv2-px-4 ppv2-px-2 ppv2-py-1.5 ppv2-text-sm poppinsMedium ppv2-transition-colors',
                            activeTypeFilter === filter.id ? 'filter-pill-active' : 'filter-pill-inactive',
                        ]"
                        @click="activeTypeFilter = filter.id"
                    >
                        {{ filter.label }}
                        <span
                            v-if="filter.count !== undefined"
                            :class="[
                                'ppv2-min-w-[24px] ppv2-h-[24px] ppv2-rounded-full ppv2-text-xs ppv2-px-1.5 ppv2-ml-1',
                                getBadgeColor(filter.id),
                            ]"
                        >
                            {{ filter.count }}
                        </span>
                    </button>
                    <div class="ppv2-flex-grow"></div>

                    <!-- Modifier les colonnes -->
                    <div class="ppv2-relative md:ppv2-block ppv2-hidden" ref="columnsDropdown">
                        <button
                            @click="showColumns = !showColumns"
                            class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20 ppv2-rounded-lg ppv2-px-3 ppv2-py-2 ppv2-text-sm ppv2-text-gray-700 hover:ppv2-bg-gray-50 ppv2-transition-colors"
                        >
                            <FilePen :size="18" />
                            <span>{{ $t('invoices.edit_columns') }}</span>
                            <ChevronDown :size="16" />
                        </button>
                        <!-- Dropdown -->
                        <div
                            v-if="showColumns"
                            class="menuDropdown ppv2-absolute ppv2-top-full ppv2-right-0 ppv2-mt-2 ppv2-rounded-md ppv2-overflow-hidden ppv2-z-50"
                        >
                            <div class="ppv2-max-h-[300px] ppv2-overflow-y-auto">
                                <label
                                    v-for="(column, index) in allColumns"
                                    :key="index"
                                    class="dropdownItem ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-1 ppv2-cursor-pointer ppv2-transition-colors"
                                >
                                    <BaseCheckbox
                                        :value="selectedColumnKeys.includes(column.key)"
                                        @input="toggleColumn(column.key)"
                                        size="sm"
                                        :hasBorderChecked="true"
                                    />
                                    <span class="poppinsLight" :style="{ fontSize: normalizeFontSize(14) }">{{
                                        column.label
                                    }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Validated Invoices DataTable -->
                <div>
                    <validated-invoices-data-table
                        ref="validatedDataTable"
                        :start-date="dateRange.start"
                        :end-date="dateRange.end"
                        :type-filter="activeTypeFilter"
                        :search-query="searchQuery"
                        :columns="visibleColumns"
                        :filters="filters"
                        @selection-changed="handleSelectionChanged"
                        @stats-updated="handleStatsUpdated"
                        @filter-counts-updated="handleFilterCountsUpdated"
                    >
                        <!-- Bulk Actions Slot -->
                        <template #bulk-actions="{ selectedCount }">
                            <span class="poppinsRegular textGray" :style="{ fontSize: normalizeFontSize(15) }">
                                {{
                                    $t('invoices.selected_items', {
                                        count: selectedCount,
                                        plural: selectedCount > 1 ? 's' : '',
                                    })
                                }}
                            </span>
                            <span
                                class="poppinsRegular ppv2-text-white ppv2-text-opacity-50"
                                :style="{ fontSize: normalizeFontSize(15) }"
                                >|</span
                            >
                            <button
                                v-if="canExportInvoices"
                                @click="exportSelection"
                                :disabled="isExportingSelection"
                                :class="isDark ? '!ppv2-border-white' : '!ppv2-border-black'"
                                style="border-radius: 14px"
                                class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-px-3 ppv2-py-1.5 ppv2-border-solid ppv2-text-white hover:ppv2-bg-white hover:ppv2-bg-opacity-10 ppv2-transition-colors"
                            >
                                <span
                                    v-if="isExportingSelection"
                                    class="ppv2-animate-spin ppv2-inline-block ppv2-w-4 ppv2-h-4 ppv2-border-2 ppv2-border-white ppv2-border-t-transparent ppv2-rounded-full"
                                ></span>
                                <svg
                                    v-else
                                    width="17"
                                    height="17"
                                    viewBox="0 0 30 30"
                                    :fill="isDark ? '#fff' : '#000'"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.21289 17.6012C1.21289 14.7752 2.69884 12.2962 4.93205 10.9029C5.53943 6.12426 9.62017 2.42969 14.5638 2.42969C19.5074 2.42969 23.5882 6.12426 24.1956 10.9029C26.4288 12.2962 27.9148 14.7752 27.9148 17.6012C27.9148 21.7541 24.7059 25.1575 20.6324 25.4675L8.49522 25.4904C4.42171 25.1575 1.21289 21.7541 1.21289 17.6012ZM20.4483 23.0469C23.2804 22.8315 25.4873 20.4609 25.4873 17.6012C25.4873 15.692 24.5023 13.9554 22.9107 12.9625L21.9328 12.3524L21.7875 11.209C21.3285 7.59775 18.24 4.85713 14.5638 4.85713C10.8877 4.85713 7.79912 7.59775 7.34012 11.209L7.19479 12.3524L6.21692 12.9625C4.62534 13.9554 3.64034 15.692 3.64034 17.6012C3.64034 20.4609 5.84728 22.8315 8.67935 23.0469L8.88968 23.063H20.238L20.4483 23.0469ZM15.7776 14.5669H19.4187L14.5638 20.6355L9.70895 14.5669H13.3501V9.71202H15.7776V14.5669Z"
                                        :fill="isDark ? '#fff' : '#000'"
                                    />
                                </svg>
                                <span :style="{ fontSize: normalizeFontSize(17) }">{{ $t('invoices.export_selection') }}</span>
                            </button>
                        </template>
                    </validated-invoices-data-table>
                </div>
            </div>
        </div>

        <!-- Advanced Filters Modal -->
        <invoice-advanced-filters-v3
            v-if="showAdvancedFilters"
            :available-filters="availableFilters"
            :current-filters="filters"
            save-url="/back-office/invoices-v3/save-filters?type=invoices_v3_validated"
            @close="showAdvancedFilters = false"
            @update="handleAdvancedFiltersUpdate"
        />

        <!-- Confirmation Dialog for clearing filters -->
        <confirmation-dialog
            :is-open="showClearFiltersDialog"
            type="warning"
            :title="$t('invoices.clear_filters_dialog.title')"
            :message="$t('invoices.clear_filters_dialog.message')"
            :confirm-button-text="$t('invoices.clear_filters_dialog.confirm')"
            :cancel-button-text="$t('invoices.clear_filters_dialog.cancel')"
            @confirm="confirmClearAllFilters"
            @cancel="cancelClearFilters"
        />
    </div>
</template>

<script>
import Search from '../V3/Experience/components/Search.vue'
import ExportSelect from '../Shared/ExportSelect.vue'
import { FileText, Plus, ChevronDown, DownloadCloud, CalendarClock, FileEdit, LayoutGrid, FilePen, Download } from 'lucide-vue'
import Header from '../Shared/Header.vue'
import InvoiceFilterBar from './components/InvoiceFilterBar.vue'
import BaseCheckbox from '../Shared/BaseCheckbox.vue'
import normalizeSize from '../../utils/normalizeSize'
import FilterDropdown from './FilterDropdown.vue'
import InvoiceAdvancedFiltersV3 from './InvoiceAdvancedFiltersV3.vue'
import ConfirmationDialog from '../Shared/ConfirmationDialog.vue'
import { X } from 'lucide-vue'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'InvoicesPageV3',
    components: {
        InvoiceFilterBar,
        Plus,
        ChevronDown,
        DownloadCloud,
        Search,
        ExportSelect,
        FileText,
        Header,
        CalendarClock,
        FileEdit,
        LayoutGrid,
        FilePen,
        BaseCheckbox,
        FilterDropdown,
        InvoiceAdvancedFiltersV3,
        ConfirmationDialog,
        X,
        Download,
    },
    props: {
        canExportInvoices: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isDark() {
            return this.theme.mode === 'dark'
        },
        // Define all available columns
        allColumns() {
            return [
                { key: 'type', label: this.$t('invoices.columns.type'), sortable: true, type: 'text' },
                { key: 'order_status', label: this.$t('invoices.columns.order_status_label'), sortable: true, type: 'badge' },
                { key: 'emission', label: this.$t('invoices.columns.emission'), sortable: true, type: 'date' },
                { key: 'due_date', label: this.$t('invoices.columns.due_date'), sortable: true, type: 'date' },
                { key: 'customer', label: this.$t('invoices.columns.customer'), sortable: true, type: 'text' },
                { key: 'fiscal_number', label: this.$t('invoices.columns.fiscal_number'), sortable: true, type: 'number' },
                { key: 'price_ht', label: this.$t('invoices.columns.price_ht'), sortable: true, type: 'number' },
                { key: 'price_ttc', label: this.$t('invoices.columns.price_ttc'), sortable: true, type: 'number' },
                // Statut du cycle de vie e-facture (AFNOR XP Z12-012). Rendu par
                // ValidatedInvoicesDataTable ; le serveur ne renvoie `e_invoice` que
                // pour les factures RÉELLEMENT transmises à la plateforme agréée.
                { key: 'e_invoice', label: 'E-facture', sortable: false, type: 'badge' },
            ]
        },
        visibleColumns() {
            return this.allColumns.filter((column) => this.selectedColumnKeys.includes(column.key))
        },
        activeFiltersCount() {
            if (!this.filters) return 0
            let count = 0
            Object.keys(this.filters).forEach((key) => {
                const value = this.filters[key]
                if (value !== null && value !== '' && (Array.isArray(value) ? value.length > 0 : true)) {
                    count++
                }
            })
            return count
        },
        activeFiltersPills() {
            if (!this.filters) return {}
            const pills = {}
            const filterLabels = {
                validated_order_invoice_id: this.$t('invoices.validated_order_invoice'),
                is_refund: this.$t('invoices.has_refund'),
                payment_method_id: this.$t('invoices.payment_method'),
                total_greater_than: this.$t('common.min'),
                total_lesser_than: this.$t('common.max'),
            }
            Object.keys(this.filters).forEach((key) => {
                const value = this.filters[key]
                if (value !== null && value !== '' && (Array.isArray(value) ? value.length > 0 : true)) {
                    const label = filterLabels[key] || key
                    pills[key] = this.getFilterPillLabel(key, value, label)
                }
            })
            return pills
        },
    },
    data() {
        return {
            loading: false,
            isExportingCsv: false,
            isExportingSelection: false,
            error: null,
            showClearFiltersDialog: false,
            activeTypeFilter: 'all',
            isExporting: false,
            searchQuery: '',
            selectedCount: 0,
            showAddDropdown: false,
            showColumns: false,
            showAdvancedFilters: false,
            selectedColumnKeys: [
                'e_invoice',
                'type',
                'order_status',
                'emission',
                'due_date',
                'customer',
                'fiscal_number',
                'price_ht',
                'price_ttc',
            ],
            dateRange: {
                start: new Date().toISOString().split('T')[0],
                end: new Date().toISOString().split('T')[0],
            },
            stats: {
                validated_invoices: { amount: 0, count: 0 },
                paid_invoices: { amount: 0, count: 0 },
                overdue_invoices: { amount: 0, count: 0 },
            },
            typeFilters: [
                { id: 'all', label: this.$t('invoices.type_filters.all'), count: 0 },
                { id: 'draft', label: this.$t('invoices.type_filters.draft'), count: 0 },
                { id: 'upcoming', label: this.$t('invoices.type_filters.upcoming'), count: 0 },
                { id: 'overdue', label: this.$t('invoices.type_filters.overdue'), count: 0 },
                { id: 'paid', label: this.$t('invoices.type_filters.paid'), count: 0 },
            ],
            validatedMeta: { total: 0 },
            exportOptions: [{ value: 'xlsx', label: 'Excel (.xlsx)' }],
            // New Filter Data
            filters: {
                validated_order_invoice_id: null,
                status_id: [],
                type_id: [],
                is_refund: null,
                voucher_id: null,
                promo_code: null,
                payment_method_id: null,
                prestations: [],
                products: [],
                packages: [],
                series: [],
                staff_id: null,
                total_greater_than: null,
                total_lesser_than: null,
            },
            availableFilters: {
                orderStatuses: [],
                types: [],
                staffs: [],
                paymentMethods: [],
                prestations: [],
                products: [],
                packages: [],
                series: [],
                vouchers: [],
                promotions: [],
            },
        }
    },
    mounted() {
        this.loadAvailableFilters()
        document.addEventListener('click', this.handleClickOutside)

        // Simulating data for preview purposes if API fails or is empty
        // this.simulateDataForPreview();
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    watch: {
        'dateRange.start'() {
            this.handleFilterChange()
        },
        'dateRange.end'() {
            this.handleFilterChange()
        },
        activeTypeFilter() {
            this.handleFilterChange()
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        async handleExport(format) {
            if (this.isExporting) return
            this.isExporting = true
            try {
                const params = new URLSearchParams()
                params.set('startDate', this.dateRange.start)
                params.set('endDate', this.dateRange.end)
                params.set('format', format)
                params.set('combined', format === 'xlsx' || format === 'xls' ? '1' : '0')
                params.set('detailed', '0')
                if (this.searchQuery) params.set('search', this.searchQuery)
                if (this.activeTypeFilter && this.activeTypeFilter !== 'all') {
                    params.set('typeFilter', this.activeTypeFilter)
                }
                if (this.filters && typeof this.filters === 'object') {
                    Object.entries(this.filters).forEach(([key, value]) => {
                        if (value !== null && value !== undefined && value !== '') {
                            if (Array.isArray(value)) {
                                value.forEach((v) => params.append(`${key}[]`, v))
                            } else {
                                params.set(key, value)
                            }
                        }
                    })
                }

                // fetch pour garder le loader actif pendant que Laravel génère le CSV
                const response = await fetch(`/back-office/invoices-v3/export-csv?${params.toString()}`, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                })

                if (!response.ok) throw new Error(`Erreur serveur: ${response.status}`)

                const blob = await response.blob()
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                const ext = format === 'xls' || format === 'xlsx' ? 'xlsx' : 'csv'
                const filenameBase = this.$t('invoices.export_filename_prefix') || 'factures_validees'
                const filename = `${filenameBase}_${new Date().toISOString().slice(0, 10)}.${ext}`
                a.href = url
                a.download = filename
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                URL.revokeObjectURL(url)
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isExporting = false
            }
        },
        getDefaultFilters() {
            return {
                validated_order_invoice_id: null,
                status_id: [],
                type_id: [],
                is_refund: null,
                voucher_id: null,
                promo_code: null,
                payment_method_id: null,
                prestations: [],
                products: [],
                packages: [],
                series: [],
                staff_id: null,
                total_greater_than: null,
                total_lesser_than: null,
            }
        },
        openAddOption1() {
            this.showAddDropdown = false
        },

        openAddOption2() {
            this.showAddDropdown = false
        },
        handleDateChange() {
            this.handleFilterChange()
        },
        async exportSelection() {
            const selectedInvoices = this.$refs.validatedDataTable?.selectedInvoices || []
            if (selectedInvoices.length === 0 || this.isExportingSelection) return
            this.isExportingSelection = true
            try {
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
                const response = await fetch('/back-office/invoices-v3/export-selection-csv', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({ ids: selectedInvoices }),
                })
                if (!response.ok) throw new Error(`Erreur serveur: ${response.status}`)
                const blob = await response.blob()
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                const filenameBase = this.$t('invoices.export_filename_selection') || 'factures_selection'
                a.download = `${filenameBase}_${new Date().toISOString().slice(0, 10)}.csv`
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                URL.revokeObjectURL(url)
            } catch (error) {
                console.error('Erreur export sélection CSV:', error)
                this.$toast.error(error.message)
            } finally {
                this.isExportingSelection = false
            }
        },
        toggleColumn(key) {
            if (this.selectedColumnKeys.includes(key)) {
                this.selectedColumnKeys = this.selectedColumnKeys.filter((k) => k !== key)
            } else {
                this.selectedColumnKeys.push(key)
            }
        },
        handleClickOutside(event) {
            const refs = ['columnsDropdown', 'columnsDropdownMobile']
            const isInside = refs.some((name) => {
                const el = this.$refs[name]
                const nodes = Array.isArray(el) ? el : [el]
                return nodes.some((node) => node && node.contains(event.target))
            })
            if (!isInside) {
                this.showColumns = false
            }
        },
        getBadgeColor(filterId) {
            switch (filterId) {
                case 'upcoming':
                    return 'ppv2-bg-[#0075FF] ppv2-text-white'
                case 'overdue':
                    return 'ppv2-bg-[#DBA800] ppv2-text-white'
                case 'paid':
                    return 'ppv2-bg-[#035B2F] ppv2-text-white'
                case 'draft':
                    return 'ppv2-bg-[#9C9C9C] ppv2-text-white'
                default:
                    return 'ppv2-bg-[#5932EA] ppv2-text-white'
            }
        },
        async loadAvailableFilters() {
            try {
                const response = await this.axios.get('/back-office/invoices-v3/filter-data', {
                    params: { type: 'invoices_v3_validated' },
                })
                const data = response.data.data || response.data // Handle Resource wrapper

                if (data) {
                    // Populate available filters
                    this.availableFilters = {
                        orderStatuses: data.orderStatuses || [],
                        // Display-only whitelist: only expose Facture / Acompte / Avoir /
                        // Facture rectificative in the type filter; the others (Devis, Pro forma,
                        // Règlement de paiement, Paiement ultérieur) stay in the backend, just hidden.
                        types: (data.invoiceTypes || []).filter((t) =>
                            ['INVOICE', 'DEPOSIT', 'CREDIT_NOTE', 'CORRECTIVE'].includes(t.name)
                        ),
                        staffs: data.staffs || [],
                        paymentMethods: data.paymentMethods || [],
                        prestations: data.prestations || [],
                        products: data.products || [],
                        packages: data.packages || [],
                        series: data.series || [],
                        vouchers: data.vouchers || [],
                        promotions: data.promotions || [],
                    }

                    // Add hardcoded types if missing (fallback)
                    if (!this.availableFilters.types || this.availableFilters.types.length === 0) {
                        this.availableFilters.types = [
                            { id: 'Anniversaire', label: 'Anniversaire' },
                            { id: 'Entreprise', label: 'Entreprise' },
                            { id: 'EVG/EVJF', label: 'EVG/EVJF' },
                            { id: 'Manuel', label: 'Manuel' },
                        ]
                    }

                    // Ensure statuses have label
                    if (this.availableFilters.orderStatuses) {
                        this.availableFilters.orderStatuses = this.availableFilters.orderStatuses.map((s) => ({
                            ...s,
                            label: s.name,
                            id: s.id,
                        }))
                    }

                    // Load saved user filters
                    if (data.userFilters && data.userFilters.filters) {
                        // Merge saved filters with default structure to ensure reactivity
                        this.filters = { ...this.getDefaultFilters(), ...data.userFilters.filters }
                        console.log('Loaded saved filters:', this.filters)
                    }
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
        handleAdvancedFiltersUpdate(newFilters) {
            this.filters = { ...this.getDefaultFilters(), ...newFilters }
            this.handleFilterChange()
        },
        getFilterPillLabel(key, value, label) {
            let displayValue = value

            if (key === 'is_refund') {
                displayValue = value ? this.$t('common.yes') : this.$t('common.no')
            } else if (key === 'validated_order_invoice_id') {
                const inv = this.availableFilters.validated_order_invoices?.find((i) => i.id === value)
                displayValue = inv ? inv.name : value
            } else if (key === 'payment_method_id' && this.availableFilters.paymentMethods) {
                const method = this.availableFilters.paymentMethods.find((m) => m.id == value)
                displayValue = method ? method.display_name : value
            } else if (Array.isArray(value)) {
                displayValue = `${value.length} ${this.$t('invoices.selected')}`
            } else if (typeof value === 'boolean') {
                displayValue = value ? this.$t('common.yes') : this.$t('common.no')
            } else if (key === 'staff_id' && this.availableFilters.staffs) {
                const staff = this.availableFilters.staffs.find((s) => s.id == value)
                displayValue = staff ? staff.full_name : value
            } else if (key === 'status_id' && this.availableFilters.orderStatuses) {
                const status = this.availableFilters.orderStatuses.find((s) => s.id == value)
                displayValue = status ? status.name : value
            }

            return {
                label: label || key,
                value: displayValue,
            }
        },
        removeFilter(filterKey) {
            const updatedFilters = { ...this.filters }
            // Reset to default value
            if (Array.isArray(updatedFilters[filterKey])) {
                updatedFilters[filterKey] = []
            } else {
                updatedFilters[filterKey] = null
            }

            this.saveFiltersToBackend(updatedFilters)
        },
        clearAllFilters() {
            this.showClearFiltersDialog = true
        },
        async confirmClearAllFilters() {
            const emptyFilters = {
                status_id: [],
                type_id: [],
                has_refund: null,
                voucher_id: null,
                promo_code: null,
                payment_method_id: null,
                prestations: [],
                products: [],
                packages: [],
                series: [],
                staff_id: null,
                total_greater_than: null,
                total_lesser_than: null,
            }
            await this.saveFiltersToBackend(emptyFilters)
            this.showClearFiltersDialog = false
        },
        cancelClearFilters() {
            this.showClearFiltersDialog = false
        },
        async saveFiltersToBackend(filters) {
            try {
                this.loading = true
                const response = await this.axios.post('/back-office/invoices-v3/save-filters', {
                    filters: filters,
                })

                if (response.data && response.data.success) {
                    this.filters = { ...this.getDefaultFilters(), ...response.data.filters }
                    this.handleFilterChange()

                    if (this.$toast) {
                        this.$toast.success(this.$t('invoices.filters_updated_success'))
                    }
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        async loadTypeCounts() {
            try {
                const response = await this.axios.get('/back-office/invoices-v3/type-counts', {
                    params: {
                        startDate: this.dateRange.start,
                        endDate: this.dateRange.end,
                    },
                })
                const data = response.data || response

                // Merge counts into existing filters to preserve UI order and structure
                if (data.filters) {
                    this.typeFilters = this.typeFilters.map((f) => {
                        const found = data.filters.find((apiF) => apiF.id === f.id)
                        return found ? { ...f, count: found.count } : f
                    })
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
        handleFilterChange() {
            this.$nextTick(() => {
                if (this.$refs.validatedDataTable) {
                    this.$refs.validatedDataTable.reload()
                }
            })
        },
        handleFilterCountsUpdated(filterCounts) {
            // Update typeFilters counts from the API response
            if (filterCounts) {
                this.typeFilters = this.typeFilters.map((f) => {
                    const found = filterCounts.find((apiF) => apiF.id === f.id)
                    return found ? { ...f, count: found.count } : f
                })
            }
        },
        handleSearchUpdate(searchValue) {
            this.searchQuery = searchValue
            this.$nextTick(() => {
                if (this.$refs.validatedDataTable) {
                    this.$refs.validatedDataTable.handleSearchUpdate(searchValue)
                }
            })
        },
        handleSelectionChanged(count) {
            this.selectedCount = count
        },
        handleStatsUpdated(stats) {
            // Update stats from the data table API response
            if (stats) {
                this.stats.validated_invoices = {
                    invoiced_amount: stats.invoiced_amount || 0,
                    collected_amount: stats.collected_amount || 0,
                }
            }
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat(this.$currencyLocale?.replace('_', '-') || 'fr-FR', {
                style: 'currency',
                currency: this.$codeCurrency,
            }).format(amount || 0)
        },
        simulateDataForPreview() {
            // Only for dev purposes to match design visual
            this.stats = {
                validated_invoices: { amount: 450382.42, count: 25 },
                paid_invoices: { amount: 899382.42, count: 18 },
                overdue_invoices: { amount: 8990.42, count: 5 },
            }
            this.typeFilters = [
                { id: 'all', label: this.$t('invoices.type_filters.all'), count: 25 },
                { id: 'draft', label: this.$t('invoices.type_filters.draft'), count: 5 },
                { id: 'upcoming', label: this.$t('invoices.type_filters.upcoming'), count: 5 },
                { id: 'overdue', label: this.$t('invoices.type_filters.overdue'), count: 5 },
                { id: 'paid', label: this.$t('invoices.type_filters.paid'), count: 5 },
            ]
        },
    },
}
</script>

<style scoped lang="scss">
.menuDropdown {
    @apply ppv2-bg-gray-900 ppv2-bg-opacity-80 ppv2-text-gray-400;
    margin-top: 10px;
    z-index: 9;
}

.dropdownItem:hover {
    @apply ppv2-bg-indigo-900 ppv2-text-white;
}

.dropdownItem:hover * {
    @apply ppv2-text-white;
}

.dark {
    .menuDropdown {
        @apply ppv2-bg-gray-800 ppv2-bg-opacity-90;
    }
}

.filter-btn {
    @apply ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-border ppv2-border-[#191D41] ppv2-rounded-xl ppv2-px-4 ppv2-py-2.5 ppv2-text-[#191D41] ppv2-bg-white hover:ppv2-bg-gray-50 ppv2-transition-colors ppv2-text-sm;
    font-family: 'Poppins Light', sans-serif;
}

.filter-pill-active {
    @apply ppv2-bg-black ppv2-text-white ppv2-shadow-lg;
}

.filter-pill-inactive {
    @apply ppv2-bg-white ppv2-text-[#021832] ppv2-border ppv2-border-gray-200 hover:ppv2-bg-gray-50;
}

.dark {
    .filter-pill-active {
        @apply ppv2-bg-white ppv2-text-black;
    }

    .filter-pill-inactive {
        @apply ppv2-bg-transparent ppv2-text-gray-300;
    }

    .selection-bar {
        @apply ppv2-bg-[#191D41];
    }

    .selection-bar-text {
        @apply ppv2-text-white;
    }

    .selection-bar-divider {
        @apply ppv2-bg-white ppv2-opacity-30;
    }

    .selection-bar-button {
        @apply ppv2-border-white ppv2-text-white hover:ppv2-bg-white hover:ppv2-bg-opacity-10;
    }
}

.selection-bar {
    @apply ppv2-bg-white ppv2-border ppv2-border-gray-200;
}

.selection-bar-text {
    @apply ppv2-text-[#021832];
}

.selection-bar-divider {
    @apply ppv2-bg-[#021832] ppv2-opacity-20;
}

.selection-bar-button {
    @apply ppv2-border-[#021832] ppv2-text-[#021832] hover:ppv2-bg-gray-50;
}

.cardCAFact {
    background-image: url('/media/bo/backgounds/bgCardFacture.png');
    background-size: cover;
    background-position: center;
    box-shadow: -1px 1px 6.7px 0px #00000040;
    border-radius: 15px;
}

.menuDropdown {
    background: white;
    color: #94a3b8;
    margin-top: 10px;
    z-index: 50;
    padding: 8px 0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dropdownItem:hover {
    background-color: #1a1f37;
    color: white !important;
}

.dropdownItem:hover * {
    color: white !important;
}
</style>
